/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Radio,
  Row,
  Col,
  Form,
  Input,
  Space,
  Button,
  Select,
  Table,
  Spin,
  message,
} from "antd";
import BottomButton from "./BottomButton";
import Heading from "./Heading";
import PinCodeValidator from "../../components/PincodeValidator";
import { getPremiseId } from "../../utils/worker";
import API from "../../api";
import urls from "../../api/urls";
const { GET_CP_MASTER_LIST_V1 } = urls;
const premiseId = getPremiseId().split("Bearer ")[1];
import { customerOnboardingAPI } from "../../api/LeadApi";
import useCustomNavigate from "../../components/customNavigationHook";

const CpDetails = ({ handleStepsChange, goBackStep }) => {
  const navigate = useCustomNavigate();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [pincode, setPincode] = useState(null);
  const [rateCardName, setRateCardName] = useState(null);

  useEffect(() => {
    getCpDetails();
  }, []);

  const getCpDetails = async () => {
    setLoading(true);
    const response = await customerOnboardingAPI.getMasterById(
      premiseId,
      GET_CP_MASTER_LIST_V1
    );
    // let response1 = await API.Api(GET_RATECARD_BY_USER + premiseId).get();
    // if (response1?.status) {
    //   let rateCardData = response1?.response?.data?.name;
    //   setRateCardName(rateCardData);

    //   form.setFieldsValue({ rateCard: rateCardData });
    // }

    if (response?.status) {
      setLoading(false);

      let data = response?.response?.data;
      form.setFieldsValue({
        cpName: data?.orgName,
        //cpType: data?.cpType,
        pincode: data?.addresses?.[0]?.pincode,
        addressLine1: `${data?.addresses?.[0]?.street} ${data?.addresses?.[0]?.city} ${data?.addresses?.[0]?.state}`,
        //addressLine2: data?.addressLine2,
        parentHub: data?.parentHub,

        zone: data?.zone,
      });
      setPincode(data?.pincode);
    } else {
      setLoading(false);
    }
  };

  const onCpDetailsFinish = (e) => {};

  return (
    <div className="cp-detail-wrapper">
      <Spin spinning={loading}>
        <Heading title={"CP Details"} />
        <Form
          className="global-form"
          layout={"vertical"}
          onFinish={onCpDetailsFinish}
          form={form}
        >
          <Row gutter={12} className="global-form-row">
            <Col md={12} lg={12} xl={12} sm={24} xs={24}>
              <Form.Item
                label="CP name"
                name="cpName"
                rules={[
                  {
                    required: true,
                    message: "Please enter CP name",
                  },
                ]}
              >
                <Input placeholder="Enter CP name" disabled />
              </Form.Item>
            </Col>
            {/* <Col md={12} lg={12} xl={12} sm={24} xs={24}>
              <Form.Item
                label="CP type"
                name="cpType"
                rules={[
                  {
                    required: true,
                    message: "Please enter CP type",
                  },
                ]}
              >
                <Input placeholder="Enter CP type" disabled />
              </Form.Item>
            </Col> */}
            {/* <Col md={12} lg={12} xl={12} sm={24} xs={24}>
              <Form.Item
                label="Parent Hub"
                name="parentHub"
                rules={[
                  {
                    required: true,
                    message: "Please enter parent hub",
                  },
                ]}
              >
                <Input placeholder="Enter parent hub" disabled />
              </Form.Item>
            </Col> */}
            {/* <Col md={12} lg={12} xl={12} sm={24} xs={24}>
              <Form.Item
                label="Zone"
                name="zone"
                rules={[
                  {
                    required: true,
                    message: "Please enter zone",
                  },
                ]}
              >
                <Input placeholder="Enter zone" disabled />
              </Form.Item>
            </Col> */}
            {/* <Col md={12} lg={12} xl={12} sm={24} xs={24}>
              <Form.Item
                label="Rate card"
                name="rateCard"
                rules={[
                  {
                    required: true,
                    message: "Please enter rate card type",
                  },
                ]}
              >
                {rateCardName ? (
                  <a
                    onClick={() =>
                      navigate(
                        `/lead-cp-approval-confirmation/pending/${premiseId}`,
                        {
                          state: {
                            type: "cp-lead",
                            rateCards: [
                              {
                                quotationName: rateCardName,
                                rateCardType: "CASH",
                                status: "pending",
                              },
                            ],
                          },
                        }
                      )
                    }
                    target="_blank" // Opens the link in a new tab. Remove this if not needed.
                    style={{ textDecoration: "underline", color: "#1890ff" }} // Add styles if needed
                  >
                    View <strong>{rateCardName}</strong>
                  </a>
                ) : (
                  "N/A"
                )}
              </Form.Item>
            </Col> */}

            <Col md={12} lg={12} xl={12} sm={24} xs={24}>
              <Form.Item
                label="Address"
                name="addressLine1"
                rules={[
                  {
                    required: true,
                    message: "Please Enter address line 1",
                  },
                ]}
              >
                <Input placeholder="Enter address line 1" disabled />
              </Form.Item>
            </Col>
            <Col md={12} lg={12} xl={12} sm={24} xs={24}>
              <Form.Item
                label="Address line 2"
                name="addressLine2"
                rules={[
                  {
                    required: false,
                    message: "Please input your username",
                  },
                ]}
              >
                <Input placeholder="Enter address line 2" disabled />
              </Form.Item>
            </Col>
            <Col md={12} lg={12} xl={12} sm={24} xs={24}>
              <PinCodeValidator formName={"pincode"} value={pincode} disabled />
            </Col>
            {/* <Col md={12} lg={12} xl={12} sm={24} xs={24}>
              <Form.Item
                label="MSME"
                name="msme"
                rules={[
                  {
                    required: true,
                    message: "Please enter MSME",
                  },
                ]}
              >
                <Radio.Group
                  onChange={msmeRadioChange}
                  defaultValue={msmeValue}
                  value={msmeValue}
                >
                  <Radio value={"Yes"}>Yes</Radio>
                  <Radio value={"No"}>No</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
            {msmeValue === "Yes" ? (
              <Col md={12} lg={12} xl={12} sm={24} xs={24}>
                <Form.Item
                  label="Upload MSME Certificate"
                  name="uploadMsmeCertificate"
                  rules={[
                    {
                      required: true,
                      message: "Please upload MSME certificate",
                    },
                  ]}
                >
                  <Dragger
                    msg={" Maximum file size 5 MB"}
                    url={
                      "https://run.mocky.io/v3/435e224c-44fb-4773-9faf-380c5e6a2188"
                    }
                    multiple={false}
                    maxCount={1}
                  />
                </Form.Item>
              </Col>
            ) : null} */}
            {/* <Col md={12} lg={12} xl={12} sm={24} xs={24}>
              <Form.Item
                label="If TAN registered?"
                name="ifTanRegistered"
                rules={[
                  {
                    required: true,
                    message: "Please select",
                  },
                ]}
              >
                <Radio.Group
                  onChange={tanRadioChange}
                  defaultValue={tanValue}
                  value={tanValue}
                >
                  <Radio value={"Yes"}>Yes</Radio>
                  <Radio value={"No"}>No</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
            {tanValue === "Yes" ? (
              <>
                <Col md={12} lg={12} xl={12} sm={24} xs={24}>
                  <Form.Item
                    label="TAN Number"
                    name="tanNumber"
                    rules={[
                      {
                        required: true,
                        message: "Please Enter TAN Number",
                      },
                    ]}
                  >
                    <Input placeholder="Enter TAN Number" />
                  </Form.Item>
                </Col>
                <Col md={12} lg={12} xl={12} sm={24} xs={24}>
                  <Form.Item
                    label="Upload TAN Certificate"
                    name="uploadTanCertificate"
                    rules={[
                      {
                        required: true,
                        message: "Please upload TAN certificate",
                      },
                    ]}
                  >
                    <Dragger
                      msg={" Maximum file size 5 MB"}
                      url={
                        "https://run.mocky.io/v3/435e224c-44fb-4773-9faf-380c5e6a2188"
                      }
                      multiple={false}
                      maxCount={1}
                    />
                  </Form.Item>
                </Col>
              </>
            ) : null} */}
          </Row>
          <hr
            className="divider"
            style={{ marginTop: "20px", marginBottom: "20px" }}
          />

          <Row
            gutter={12}
            className="mt-2"
            justify={"end"}
            style={{ flex: "auto" }}
          >
            <Col>
              <Button className="cancel-btn" onClick={goBackStep}>
                BACK
              </Button>
            </Col>
            <Col>
              <Form.Item>
                <Button
                  className="save-btn"
                  onClick={() => handleStepsChange()}
                >
                  NEXT
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Spin>
    </div>
  );
};

export default CpDetails;
